import { Colors, Fonts } from '@estee/elc-base-theme';

export const dropdownContainerTheme = () => `
    color: ${Colors.primary700};
    font-family: ${Fonts.roboto};
`;

export const dropdownArrowButtonTheme = () => `
    border-color: ${Colors.primary300};
    svg {
        fill: ${Colors.primary700};
    }
`;
export const iconDisabledTheme = () => `
    border-color: ${Colors.blackPaleEmphasis};
    svg {
        fill: ${Colors.blackPaleEmphasis};
    }
`;

export const dropdownInputWrapperTheme = () => `
    border-color: ${Colors.primary300};
    border-radius: 2px;
`;

export const dropdownItemsTheme = () => `
    border-color: ${Colors.primary300};
`;

export const dropdownItemTheme = () => `
    font-size: 13px;
    &:hover {
        background-color: ${Colors.primary100};
    }
`;

export const labelTheme = () => `
    font-family: ${Fonts.robotoMedium};
    font-size: 14px;
`;

export const dropdownBackgroundTheme = () => `
    background: ${Colors.white};
`;

export const dropdownDisabledTheme = () => `
   border-color:  ${Colors.blackPaleEmphasis};
`;
